export const OPTION = {
    CUSTOM: "custom",
    ACTIVE: "active"
};

export const OPERATORS = (name) => {
    if (name === "billing_frequency") {
        return [
            {
                label: "is",
                value: "is"
            }
        ];
    }

    return [
        {
            label: "Greater Than",
            value: "greater_than"
        },
        {
            label: "Greater Than Or Equals To",
            value: "greater_than_or_equals_to"
        },
        {
            label: "Less Than Or Equals To",
            value: "less_than_or_equals_to"
        },
        {
            label: "Less Than",
            value: "less_than"
        },
        {
            label: "Equals To",
            value: "equals_to"
        }
    ];
};

export const CONDITION_NAME = (condition) => {
    switch (condition) {
    case "attribute":
        return [
            {
                label: "MRR",
                value: "mrr"
            },
            {
                label: "Conversion Quota Used",
                value: "conversion_quota"
            },
            {
                label: "Billing Frequency",
                value: "billing_frequency"
            },
            {
                label: "Next Billing Date",
                value: "next_billing_date"
            }
        ];
    default:
        return [];
    }
};

export const ACTION_TYPES = [
    {
        label: "Task",
        value: "new_task"
    },
    {
        label: "Survey",
        value: "send_survey"
    }
];

export const CONDITIONS = [
    {
        label: "Attribute",
        value: "attribute"
    }
];
export const CONDITIONS_VALUE = [
    {
        label: "Monthly",
        value: "monthly"
    }
];
